import { createFileRoute } from "@tanstack/react-router"
import { PaginationSearchSchema } from "modules/shared/hooks/usePagination"
import { Usage } from "modules/subscription/components/Usage"
import { z } from "zod"

const SearchSchema = PaginationSearchSchema.extend({
  checkout: z.enum(["success", "cancel"]).optional(),
})

export const Route = createFileRoute("/_base/_auth/settings/subscription/usage")({
  component: Component,
  validateSearch: SearchSchema,
})

function Component() {
  const search = Route.useSearch()

  return <Usage fullPath={Route.fullPath} search={search} />
}
